<template>
  <div class="row sustine-container">
    <div class="col-lg-5 offset-lg-0 col-sm-8 offset-sm-2 col-12 order">
      <div class="text-center">
        <carousel :items=1 :nav="false" class="buyfrom" @drag="dragFunction">
          <template slot="prev"><span class="prevarrow"><img src="../../assets/images/pentru-imunitate/prev.png" alt=""></span></template>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item1.png">
            <button id="bt6" class="btn  cumpara-prin" v-on:click="bt6()" style="margin: auto; margin-top: 80px">
              <img src="../../assets/images/preparare-formule/cart.png" alt="" style="max-width: 20px !important">
              Cumpără prin
              <img src="../../assets/images/preparare-formule/arrow.png" alt=""></button>
          </div>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item2.png">
            <button id="bt7" class="btn  cumpara-prin" v-on:click="bt7()" style="margin: auto; margin-top: 78px">
              <img src="../../assets/images/preparare-formule/cart.png" alt="" style="max-width: 20px !important">
              Cumpără prin
              <img src="../../assets/images/preparare-formule/arrow.png" alt=""></button>
          </div>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item3.png">
            <button id="bt8" class="btn  cumpara-prin" v-on:click="bt8()" style="margin: auto; margin-top: 78px">
              <img src="../../assets/images/preparare-formule/cart.png" alt="" style="max-width: 20px !important">
              Cumpără prin
              <img src="../../assets/images/preparare-formule/arrow.png" alt=""></button>
          </div>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/aptamil-1plus-1200g.png">
            <a id="bt9" class="btn  cumpara-prin" href="https://www.aptanutricia.ro/nutribiotik-1an-1200" style="margin: auto; margin-top: 78px">Află mai multe</a>
          </div>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/aptamil-2plus-1200g.png">
            <a id="bt10" class="btn  cumpara-prin" href="https://www.aptanutricia.ro/nutribiotik-2ani-1200" style="margin: auto; margin-top: 78px">Află mai multe</a>
          </div>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/05941209023207_C1C1_s15_100017387.png" style="margin-bottom: 140px;">
            <a id="bt11" class="btn  cumpara-prin" href="https://www.aptanutricia.ro/aptamil-nutribiotik-lichid-1an" style="margin: auto; margin-top: 78px">Află mai multe</a>
          </div>
          <div>
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/05941209023184_C1C1_s01_100017384.png" style="margin-bottom: 140px;">
            <a id="bt12" class="btn  cumpara-prin" href="https://www.aptanutricia.ro/aptamil-nutribiotik-lichid-2ani" style="margin: auto; margin-top: 78px">Află mai multe</a>
          </div>
          <template slot="next"><span class="nextarrow"><img src="../../assets/images/pentru-imunitate/next.png" alt=""></span></template>
        </carousel>
      </div>
    </div>
    <div class="col-lg-7 col-12" style="padding: 0 20px">
      <h1 class="title-ap text-center">Susține-i sistemul <br> imunitar cu Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> <br> Lapte pentru copii de vârstă mică</h1>
      <p class="text-center"> Inspirat de 50 de ani de cercetare avansată a laptelui matern, Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> Lapte pentru copii de vârstă mică este special conceput să susțină sistemul imunitar¹, datorită imuno-nutrienților prezenți în mod natural și în laptele matern¹ </p>
      <div class="row text-left d-none d-lg-flex">
        <div class="col-lg-6 col-12">
          <div class="row align-items-baseline">
            <div class="col-1">
              <img src="../../assets/images/pentru-imunitate/bullet.png">
            </div>
            <div class="col col-title-check ">
              <h2 class="title-check ">Imuno-nutrienți</h2>
              <p>Vitaminele C&D, în cantitățile adecvate vârstei, contribuie la funcționarea normală a sistemului imunitar.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="row align-items-baseline">
            <div class="col-1">
              <img src="../../assets/images/pentru-imunitate/bullet.png">
            </div>
            <div class="col col-title-check">
              <h2 class="title-check">Nutri-Fibre</h2>
              <p>Mixul nostru unic de oligozaharide: GOS/FOS² și 3’-GL³ – o oligozaharidă cu structură identică celei regăsite în laptele matern.</p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="row align-items-baseline">
            <div class="col-1">
              <img src="../../assets/images/pentru-imunitate/bullet.png">
            </div>
            <div class="col col-title-check">
              <h2 class="title-check">Omega 3 și Omega 6</h2>
              <p>Unii dintre nutrienții prezenți în mod natural și în laptele matern.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row text-left d-block d-lg-none order-3" style="padding: 20px; margin: 0">
      <div class="col-lg-6 col-12">
        <div class="row align-items-baseline">
          <div class="col-1">
            <img src="../../assets/images/pentru-imunitate/bullet.png">
          </div>
          <div class="col col-title-check ">
            <h2 class="title-check ">Imuno-nutrienți</h2>
            <p>Vitaminele C&D, în cantitățile adecvate vârstei, contribuie la funcționarea normală a sistemului imunitar.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="row align-items-baseline">
          <div class="col-1">
            <img src="../../assets/images/pentru-imunitate/bullet.png">
          </div>
          <div class="col col-title-check">
            <h2 class="title-check">Nutri-Fibre</h2>
            <p>Mixul nostru unic de oligozaharide: GOS/FOS² și 3’-GL³ – o oligozaharidă cu structură identică celei regăsite în laptele matern.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="row align-items-baseline">
          <div class="col-1">
            <img src="../../assets/images/pentru-imunitate/bullet.png">
          </div>
          <div class="col col-title-check">
            <h2 class="title-check">Omega 3 și Omega 6</h2>
            <p>Unii dintre nutrienții prezenți în mod natural și în laptele matern.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import carousel from 'vue-owl-carousel'

export default {

  components: {carousel},
  props: ["mobile_component"],
  data() {
    return {}
  },
  methods: {
    dragFunction() {
      document.getElementById('buy_now').click();
    },
    goTo() {
      window.fbq('track', 'Comanda-Acum');
      window.gtag('event', 'click', {'event_category': 'buton-cumpara-acum'});
      // window.open("https://www.emag.ro/lapte-praf-bebelusi/brand/nutricia/c?ref=bc&utm_source=aptanutricia&utm_medium=click_imunitate&utm_campaign=campanie-ctbm&utm_content=buton_cumpara_acum", '_blank');
    },
    bt6() {
      document.getElementById('bt6').classList.toggle('open');
      document.getElementById('buy6').classList.toggle('show-buy')
      var offsets = document.getElementById('bt6').getBoundingClientRect();
      document.getElementById('buy6').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy6').style.left = offsets.left + 'px';
    },
    bt7() {
      document.getElementById('bt7').classList.toggle('open');
      document.getElementById('buy7').classList.toggle('show-buy')
      var offsets = document.getElementById('bt7').getBoundingClientRect();
      document.getElementById('buy7').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy7').style.left = offsets.left + 'px';
    },
    bt8() {
      document.getElementById('bt8').classList.toggle('open');
      document.getElementById('buy8').classList.toggle('show-buy')
      var offsets = document.getElementById('bt8').getBoundingClientRect();
      document.getElementById('buy8').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy8').style.left = offsets.left + 'px';
    },
    bt9() {
      document.getElementById('bt9').classList.toggle('open');
      document.getElementById('buy9').classList.toggle('show-buy')
      var offsets = document.getElementById('bt9').getBoundingClientRect();
      document.getElementById('buy9').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy9').style.left = offsets.left + 'px';
    },
    bt10() {
      document.getElementById('bt10').classList.toggle('open');
      document.getElementById('buy10').classList.toggle('show-buy')
      var offsets = document.getElementById('bt10').getBoundingClientRect();
      document.getElementById('buy10').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy10').style.left = offsets.left + 'px';
    },
    bt11() {
      document.getElementById('bt11').classList.toggle('open');
      document.getElementById('buy11').classList.toggle('show-buy')
      var offsets = document.getElementById('bt11').getBoundingClientRect();
      document.getElementById('buy11').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy11').style.left = offsets.left + 'px';
    },
    bt12() {
      document.getElementById('bt12').classList.toggle('open');
      document.getElementById('buy12').classList.toggle('show-buy')
      var offsets = document.getElementById('bt12').getBoundingClientRect();
      document.getElementById('buy12').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy12').style.left = offsets.left + 'px';
    },
  }
}
</script>
<style>
.show-buy {
  display: flex;

}

.open {
  border-radius: 20px 20px 0 0 !important;
}

.dropdown-menu2 {
  font-weight: 400;
  line-height: 1.5;
  float: left;
  min-width: 10rem;
  margin: .125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  right: auto;
  bottom: auto;
  z-index: 9;
  width: 100%;
  padding: 15px 20px 20px;
  max-width: 235px;
  border-radius: 0 0 30px 30px;
  border: none;
  box-shadow: 0 0 20px 0 rgba(145, 145, 145, 0.2);
  height: auto;
  position: absolute;
  transform: translate3d(0px, 50px, 0px);
  top: 455px;
  left: 54px;
  flex-direction: column;
  justify-content: center;
}

.buyfrom .owl-carousel .owl-dots {
  position: absolute;
  width: 100%;
  top: 418px;
}

.owl-carousel .owl-item img {
  width: auto !important;
  margin: auto;
  max-width: 336px !important;
  max-height: 428px !important;
}

.prevarrow {
  left: 20px;
  top: 200px;
  position: absolute;
  z-index: 100;
}

.prevarrow:hover {
  cursor: pointer;
}

.nextarrow {
  position: absolute;
  right: 20px;
  top: 200px;
  z-index: 100;
}

.nextarrow:hover {
  cursor: pointer;
}

.col-title-check {
  padding: 0;
}

.sustine-container {
  margin-bottom: 60px;
}

@media only screen and (max-width: 768px) {
  .img-produs {
    max-height: 250px;
  }

  .prev {
    position: absolute;
    left: 30px;
    top: 130px;
  }

  .next {
    position: absolute;
    right: 30px;
    top: 130px;
  }
}

@media screen and (max-width: 526px) {
  .buyfrom .owl-carousel .owl-dots {
    /*top: 278px;*/
  }

  .dropdown-menu2 {
    /*top: 328px ;*/
    /*left: 30px ;*/
    max-width: 290px;
  }
}
</style>
